import { render, staticRenderFns } from "./listPracticeQuestion.vue?vue&type=template&id=4b2fb17f&"
import script from "./listPracticeQuestion.vue?vue&type=script&lang=js&"
export * from "./listPracticeQuestion.vue?vue&type=script&lang=js&"
import style0 from "./listPracticeQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports